import React from "react";

const PRESETS = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "last_3d", label: "3d" },
  { key: "last_7d", label: "7d" },
  { key: "last_14d", label: "14d" },
  { key: "last_30d", label: "30d" },
  { key: "this_week", label: "This week" },
  { key: "this_month", label: "This month" },
];

// Reporting-range control (spec §4): presets, custom range, compare toggle.
export default function DateRangePicker({ value, onChange, compare, onCompareChange }) {
  const { range, from, to } = value;

  const pickPreset = (key) => onChange({ range: key, from: "", to: "" });
  const pickCustom = (patch) => onChange({ range: "custom", from, to, ...patch });

  return (
    <div className="range-picker">
      <div className="range-presets">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            className={`range-chip ${range === p.key ? "active" : ""}`}
            onClick={() => pickPreset(p.key)}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div className="range-custom">
        <input type="date" value={from || ""} onChange={(e) => pickCustom({ from: e.target.value })} aria-label="From date" />
        <span className="range-sep">→</span>
        <input type="date" value={to || ""} onChange={(e) => pickCustom({ to: e.target.value })} aria-label="To date" />
      </div>

      <label className="range-compare">
        <input type="checkbox" checked={compare} onChange={(e) => onCompareChange(e.target.checked)} />
        Compare to previous period
      </label>
    </div>
  );
}
